import { defaultConfig } from './defaultQuickSteps';
import intializeQuickSteps from '../actions/initializeQuickSteps';

export default function loadQuickSteps() {
    // TODO: 147494 add a reset flight here

    intializeQuickSteps(defaultConfig);

    // TODO: 145555 Load the stringified json from the user configuration,
    // parse it, validate it and call the initialize function with it
}
